import React from 'react';
import { TERMS_DOCUMENT } from '../legal/terms';
import LegalDocumentPage from '../marketing/pages/LegalDocumentPage';

/**
 * /terms — the patient-facing membership terms. The text lives in
 * src/legal/terms.ts (a verbatim port of the controlled document) and the
 * shell in src/marketing/pages/LegalDocumentPage.tsx. This route keeps its
 * path because the consent gate and enrolment link to it.
 */
const TermsPage: React.FC = () => <LegalDocumentPage document={TERMS_DOCUMENT} />;

export default TermsPage;
